import React from "react";
import ErrorField from "./error";
import { TextField } from "components/support";
import { observer } from "mobx-react";

const CategoryField = ({ errors, row, onChange }) => {
  const { category } = row;
  const foundErrors = errors.find(v => v.name === row.name);
  const hasErrors =
    foundErrors && !!foundErrors.errors && !!foundErrors.errors.category;

  return (
    <div>
      <TextField
        value={category}
        onChange={(_, value) => onChange(value)}
        fullWidth
      />
      {hasErrors && <ErrorField error={foundErrors.errors.category} />}
    </div>
  );
};

export default observer(CategoryField);



// WEBPACK FOOTER //
// ./src/components/app/registration/product/batch/fields/category.js